import {
  DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  DEFAULT_IMAGE_TRANSFORMATIONS,
  PictureDesktopNames,
} from 'common/components';
import { WINDOWS_LANDING_NAME } from '../../windows-constants';

export const INTERIOR_BIG_IMAGE_TRANSFORMATION = {
  ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgLargeDesk]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgLargeDesk,
    height: 656,
  },
  [PictureDesktopNames.ImgDesk]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgDesk,
    height: 656,
  },
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgTablet,
    height: 784,
    width: 660,
  },
  [PictureDesktopNames.ImgMobile]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgMobile,
    height: 272,
  },
};

const INTERIOR_GALLERY_DEFAULT_BIG_IMAGE_TRANSFORMATION = {
  ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_BIG_IMAGE_TRANSFORMATIONS.imgTablet,
    height: 784,
    width: 660,
  },
};

const INTERIOR_GALLERY_IMAGE_TRANSFORMATION = {
  ...DEFAULT_IMAGE_TRANSFORMATIONS,
  [PictureDesktopNames.ImgTablet]: {
    ...DEFAULT_IMAGE_TRANSFORMATIONS.imgTablet,
    height: 380,
    width: 660,
  },
};

export const IMAGE_PER_PAGE = 5;

export const getWindowsTransformationGalleryList = (isCertificateVisible: boolean) =>
  Array(20)
    .fill(null)
    .map((_, index: number) => {
      const imageName = index + 1;

      const baseInfo = {
        alt: 'Окна в разных интерьерах',
        name: `${imageName}.jpg`,
        src: `${WINDOWS_LANDING_NAME}/interior-popup/${imageName}.jpg/${imageName}.jpg`,
        srcSmall: `${WINDOWS_LANDING_NAME}/interior/${imageName}.jpg/${imageName}.jpg`,
        transformations: INTERIOR_GALLERY_IMAGE_TRANSFORMATION,
      };

      if (isCertificateVisible && index === 4) {
        return {
          ...baseInfo,
          transformations: INTERIOR_BIG_IMAGE_TRANSFORMATION,
        };
      }

      if (index % 10 === 4 || index % 10 === 7) {
        return {
          ...baseInfo,
          transformations: INTERIOR_GALLERY_DEFAULT_BIG_IMAGE_TRANSFORMATION,
        };
      }

      return baseInfo;
    });
